import debounce from "lodash/debounce";
import { useEffect, useMemo, useRef } from "react";
export var useDebounce = function (callback) {
    var ref = useRef();
    useEffect(function () {
        ref.current = callback;
    }, [callback]);
    var debouncedCallback = useMemo(function () {
        var func = function () {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref);
        };
        return debounce(func, 1000);
    }, []);
    return debouncedCallback;
};
